// Forked into ../redesign/SearchInput.tsx — keep in sync until phase_0 cleanup.
import React from 'react';
import { useTranslate } from '@bynder/localization';
import { CSRF } from '../../../helpers/csrf';
import { isModule } from '../../../helpers/windowLocation';
import { useSpotlightCapabilities } from '../hooks/useSpotlightCapabilities';
import { useSearchMode, useSpotlightDropdownContext, useSearch } from '../SpotlightState';

interface SearchInputProps {
	collectionId: string | undefined;
}

export function SearchInput({ collectionId }: SearchInputProps) {
	const { searchTerm, onValueChange } = useSearch();
	const { refInput, openSpotlightDropdown } = useSpotlightDropdownContext();
	const { isPerformingNLSSearch } = useSearchMode();
	const { translate } = useTranslate();
	const { canShowStickySearch } = useSpotlightCapabilities();
	const isCollectionModule = isModule('collections');

	const getPlaceholderText = () => {
		if (isPerformingNLSSearch) {
			return translate('spotlight.searchSomethingNLS');
		}

		return translate('spotlight.searchSomething');
	};

	return (
		<form
			id="spotlightForm"
			name="nav-search"
			action="/search/set/"
			data-action="/search/spotlight/"
			method="post"
			onSubmitCapture={(event) => event.preventDefault()}
		>
			<input type="hidden" name="csrf" value={CSRF} />
			<input type="hidden" name="filterType" value="add" />

			{canShowStickySearch ? (
				<input type="hidden" name="field" value="singletext" />
			) : (
				<input type="hidden" name="field" value="text" />
			)}

			<input
				ref={refInput}
				id="focus-new"
				name="value"
				value={searchTerm}
				placeholder={getPlaceholderText()}
				className="search"
				autoComplete="off"
				onChange={onValueChange}
				onClick={openSpotlightDropdown}
				onFocus={openSpotlightDropdown}
				style={{
					padding: 0,
					background: 'transparent',
					border: 'none',
				}}
				data-testid="spotlight-input-new-UI"
			/>
			{isCollectionModule && collectionId && (
				<input type="hidden" name="collectionId" value={collectionId} />
			)}
		</form>
	);
}
